import { Link } from 'react-router-dom';

export default function ReportCta() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-16 md:px-6 md:pb-24">
      <div className="relative overflow-hidden rounded-lg border border-background-200 bg-secondary-950">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20anonymous%20whistleblower%20silhouette%20sending%20light%20signals%20into%20a%20dark%20grid%2C%20deep%20teal%20and%20amber%20glow%2C%20minimal%20clean%20composition%2C%20serious%20tone&width=1600&height=600&seq=home-cta-2026&orientation=landscape"
            alt="匿名线索报料示意插图"
            title="向黑料雷达提交安全事件线索"
            className="h-full w-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-secondary-950 via-secondary-950/85 to-secondary-950/40"></div>
        </div>
        <div className="relative mx-auto max-w-3xl px-5 py-12 md:px-12 md:py-16">
          <p className="text-xs font-medium tracking-[0.2em] text-accent-300">线索报料</p>
          <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
            如果你遇到过，别人也需要知道
          </h2>
          <p className="mt-4 text-sm leading-7 text-background-200">
            无论是信息泄露短信、异常扣款记录，还是你在使用某个平台时发现的权限越界行为，
            都欢迎告诉我们。报料可匿名，我们只对信息本身做核实，不对提供者做身份披露。
          </p>
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/contact"
              className="whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-500"
            >
              填写报料表单
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-center text-sm text-background-100 transition-colors hover:bg-background-50/10"
            >
              了解内容原则
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}